// Auto-generated carousel images utility
// This file is automatically generated by scripts/generateCarouselImports.js
// To regenerate, run: npm run generate-carousel-imports

import image1 from '../assets/carouselImages/2030a133-c144-4cdd-be7d-ebc9c4b27446.jpg';
import image2 from '../assets/carouselImages/50045b31-0087-43b7-a03a-1dedf382b22e.JPG';
import image3 from '../assets/carouselImages/5ce293ec-9531-4391-aeda-a665cad07e59.JPG';
import image4 from '../assets/carouselImages/6cf5eaae-fe5f-4d7f-940a-c23fc54f4511.JPG';
import image5 from '../assets/carouselImages/IMG_0694.jpg';
import image6 from '../assets/carouselImages/IMG_0849.jpg';
import image7 from '../assets/carouselImages/IMG_0861.jpg';
import image8 from '../assets/carouselImages/IMG_0897.jpg';
import image9 from '../assets/carouselImages/IMG_0899.jpg';
import image10 from '../assets/carouselImages/IMG_0906.jpg';
import image11 from '../assets/carouselImages/IMG_0909.jpg';
import image12 from '../assets/carouselImages/IMG_1029.jpg';
import image13 from '../assets/carouselImages/IMG_1212.jpg';
import image14 from '../assets/carouselImages/IMG_1245.jpg';
import image15 from '../assets/carouselImages/IMG_1251.JPG';
import image16 from '../assets/carouselImages/IMG_1263.PNG';
import image17 from '../assets/carouselImages/IMG_1278.jpg';
import image18 from '../assets/carouselImages/IMG_1325.PNG';
import image19 from '../assets/carouselImages/IMG_1398.jpg';
import image20 from '../assets/carouselImages/IMG_1421.jpg';
import image21 from '../assets/carouselImages/IMG_1472.jpg';
import image22 from '../assets/carouselImages/IMG_1483.jpg';
import image23 from '../assets/carouselImages/IMG_1504.jpg';
import image24 from '../assets/carouselImages/IMG_1562.jpg';
import image25 from '../assets/carouselImages/IMG_1626.jpg';
import image26 from '../assets/carouselImages/IMG_1647.jpg';
import image27 from '../assets/carouselImages/IMG_1844.jpg';
import image28 from '../assets/carouselImages/IMG_1847.jpg';
import image29 from '../assets/carouselImages/IMG_1850.jpg';
import image30 from '../assets/carouselImages/IMG_1853.jpg';
import image31 from '../assets/carouselImages/IMG_1880.jpg';
import image32 from '../assets/carouselImages/IMG_1905.jpg';
import image33 from '../assets/carouselImages/IMG_1926.jpg';
import image34 from '../assets/carouselImages/IMG_2004.jpg';
import image35 from '../assets/carouselImages/IMG_2013.PNG';
import image36 from '../assets/carouselImages/IMG_2030.jpg';
import image37 from '../assets/carouselImages/IMG_2032.jpg';
import image38 from '../assets/carouselImages/IMG_2043.jpg';
import image39 from '../assets/carouselImages/IMG_2096.jpg';
import image40 from '../assets/carouselImages/IMG_2214.PNG';
import image41 from '../assets/carouselImages/IMG_8316.jpg';
import image42 from '../assets/carouselImages/IMG_8332.jpg';
import image43 from '../assets/carouselImages/a26b4fc1-aad0-4e71-84c6-5b04ea896eda.JPG';
import image44 from '../assets/carouselImages/a7770dad-3b7f-4cb4-a185-a8f01922e605.JPG';
import image45 from '../assets/carouselImages/b0be0f9c-7c8b-4471-9826-af915bfe6a69.JPG';
import image46 from '../assets/carouselImages/c4454a48-b4e1-4379-8c24-7c1b166a7046.JPG';

// Simple list of carousel images
export const carouselImages = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image30,
  image31,
  image32,
  image33,
  image34,
  image35,
  image36,
  image37,
  image38,
  image39,
  image40,
  image41,
  image42,
  image43,
  image44,
  image45,
  image46
];

export const getCarouselImages = async (): Promise<string[]> => {
  try {
    return carouselImages;
  } catch (error) {
    console.error('Error loading carousel images:', error);
    throw error;
  }
};

// Helper function to get image count
export const getImageCount = (): number => {
  return carouselImages.length;
};

// Helper function to get image by index
export const getImageByIndex = (index: number): string | null => {
  return carouselImages[index] || null;
};
